// extracted by mini-css-extract-plugin
export default {"titleWrapCenter":"TitleWrapper_titleWrapCenter__2JlgO"};